import React, { useEffect } from "react";
import { Box, Typography } from "@mui/material";
import { useLocation } from "react-router-dom";
import { NAV } from "../Navbar/navbarTheme";

const ContentPageLayout = ({ title, subtitle, children, centerTitle = false }) => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <Box
      sx={{
        px: { xs: 2.5, sm: 3, md: 4 },
        py: { xs: 3, md: 4 },
        maxWidth: 1100,
        mx: "auto",
        width: "100%",
        boxSizing: "border-box",
      }}
    >
      <Typography
        component="h1"
        sx={{
          color: NAV.navy,
          fontSize: { xs: "1.5rem", md: "1.75rem" },
          fontWeight: 700,
          mb: subtitle ? 1 : 2,
          textAlign: centerTitle ? "center" : "left",
        }}
      >
        {title}
      </Typography>
      {subtitle ? (
        <Typography
          sx={{
            color: NAV.inkMuted,
            fontSize: { xs: "0.9375rem", md: "1rem" },
            mb: 3,
            lineHeight: 1.5,
            textAlign: centerTitle ? "center" : "left",
          }}
        >
          {subtitle}
        </Typography>
      ) : null}
      {children}
    </Box>
  );
};

export const bodyTextSx = {
  color: NAV.ink,
  fontSize: { xs: "1rem", md: "1.0625rem" },
  lineHeight: 1.65,
  mb: 2,
};

export const sectionTitleSx = {
  color: NAV.navy,
  fontSize: { xs: "1.125rem", md: "1.25rem" },
  fontWeight: 700,
  mt: 3,
  mb: 1.5,
};

export default ContentPageLayout;
